/**
 * Имя UXFB-события каталога ЖК. Должно побайтово совпадать с кампаниями в админке UXFB;
 * сценарии различаются атрибутом `action`, кампании таргетируются на него.
 */
export const UXFB_EVENT_ZHK_CATALOG = 'zhk_catalog';

/** Значение атрибута `action`: заход в каталог. */
export const UXFB_ACTION_OPEN = 'open';

/** Значение атрибута `action`: скролл каталога (просмотрено ≥ 10 ЖК). */
export const UXFB_ACTION_SCROLL = 'scroll';

/** Количество ЖК, после скролла которых уходит событие с `action: scroll` (в атрибуте `count` — строкой). */
export const UXFB_SCROLL_ZHK_CATALOG_COUNT = 10;

/** Каталог ЖК рендерится этим сервисом только на десктопе. */
export const UXFB_PLATFORM = 'desktop';

/**
 * Kill-switch клиентских UXFB-событий. По умолчанию события включены; выключаются значением `false`
 * в конфиге (`uxfeedback.clientEvents.enabled`).
 */
export const UXFB_CLIENT_EVENTS_CONFIG_KEY = 'uxfeedback.clientEvents.enabled';
